import MyProductCard from '@Components/MyProductCard';
import Empty from '@Components/ProfilePage/ِEmpty';
import ReservationHeader from '@Components/ReservationsPage/ReservationsHeader';
import { _GetProfileOrders } from '@Services/Orders';
import { K_Orders } from '@Utils/ReactQuery.keys';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import Bag from 'public/shopping-bag.svg';
import { useQuery } from 'react-query';
import { Div } from './MyProductsSection.styled';
type Props = {};

export default function MyProductsSection({}: Props) {
  const { t } = useTranslation('Profile');
  const { locale } = useRouter();
  const { data: userOrders } = useQuery(
    K_Orders({
      locale,
    }),
    () => _GetProfileOrders()
  );

  return (
    <Div>
      <ReservationHeader title={t('my_products')}></ReservationHeader>
      {/* <GeneralProfileCard showServiceDetails={() => setShowDetails(!showDetails)} /> */}
      {userOrders && Boolean(userOrders?.results.length) ? (
        userOrders?.results.map((order) => <MyProductCard key={order.id} data={order} />)
      ) : (
        <Empty icon={Bag} title={t('no_reservations')} addLabel={t('explore_more')} />
      )}
      {/* {decline && (
        <>
          <Overlay isActive={decline} />
          <Dialogue title={t('decline_request')} close={() => setDecline(false)}>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Laudantium iure harum deserunt natus doloremque
            eligendi, soluta sequi similique. Numquam veniam ducimus nesciunt ipsam eius culpa repudiandae aliquid
            explicabo deserunt enim!
          </Dialogue>
        </>
      )} */}
    </Div>
  );
}
